document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".wp-block-cyjax-tabs-trigger");
  const items = document.querySelectorAll(".wp-block-cyjax-tabs-item");
  const itemsWrapper = document.querySelector(".wp-block-cyjax-tabs-items");

  function updateWrapperHeight() {
    const activeItem = document.querySelector(
      ".wp-block-cyjax-tabs-item.active",
    );
    if (activeItem) {
      itemsWrapper.style.height = `${activeItem.offsetHeight}px`;
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const index = trigger.getAttribute("data-index");

      // Remove active class from all triggers and items
      triggers.forEach((t) => t.classList.remove("active"));
      items.forEach((item) => {
        item.classList.remove("active");
        item.style.visibility = "hidden"; // Ensure visibility is set to hidden
      });

      // Add active class to the clicked trigger and corresponding item
      trigger.classList.add("active");
      items.forEach((item) => {
        if (item.getAttribute("data-index") === index) {
          item.style.visibility = "visible"; // Set visibility to visible before adding active class
          requestAnimationFrame(() => {
            item.classList.add("active");
            updateWrapperHeight(); // Update the wrapper height after adding the active class
          });
        }
      });
    });
  });

  // Initially hide all items except the first one and add active class to the first trigger and item
  if (items.length > 0) {
    items[0].style.visibility = "visible";
    requestAnimationFrame(() => {
      items[0].classList.add("active");
      updateWrapperHeight(); // Update the wrapper height initially
    });
  }
  if (triggers.length > 0) {
    triggers[0].classList.add("active");
  }

  // Update the wrapper height on window resize
  window.addEventListener("resize", updateWrapperHeight);
});
